//SELECTORES
nbf.selector = function(){
	/**
	 * Crea un nuevo selector a partir de sus datos de entrada y sus bloques DOM
	 * @param claseSelector string Clase interna (PHP) del selector
	 * @param propiedades Object Propiedades del selector
	 * @param valorInicial Object Valor inicial del selector (opcional)
	 * @param navegacionInicial Object Datos de navegación inicial del selector (opcional)
	 * @param editable bool True si es editable, false en caso contrario
	 * @param multiple bool True si es múltiple, false en caso contrario
	 * @param jqInfo jQuery Bloque para mostrar la info (opcional)
	 * @param jqInput jQuery Campo input hidden asociado (opcional)
	 */
	function Selector(claseSelector,propiedades,valorInicial,navegacionInicial,editable,multiple,jqInfo,jqInput){
		var thisSel = this;

		/**
		 * Actualiza/muestra el bloque de navegación del selector
		 * @param funcionOk function Función a ejecutar cuando se haya actualizado
		 */
		this.actualizarNavegacion = function(funcionOk){
			if(this.deshabilitado())
				return;
			nbf.ejecutar(
				this.claseSelector+"::ajaxParsearNavegacion",
				[this.propiedades,this.navegacion,this.valor],
				function(datos){
					if($.isPlainObject(datos)){
						thisSel.navegacion = datos.navegacion;
						thisSel.valor = datos.valor;
						if(datos.finalizar)
							thisSel.asignarValor(datos.valor);
						else{
							nbf.ejecutar(
								thisSel.claseSelector+"::ajaxNavegacion",
								[thisSel.propiedades,thisSel.navegacion,thisSel.valor],
								function(respuesta){
									if(respuesta.status=="ok"){
										if(!thisSel.noEncolarHistorial)
											thisSel.historialNavegacion.push(nbf.toJSON(thisSel.navegacion));
										thisSel.mostrarNavegacion();
										var jqPagina = $(respuesta.html);
										thisSel.jqNavegacion.html(jqPagina);
										ui.init(jqPagina);
										jqPagina.checkOverscroll();
										if(funcionOk)
											funcionOk(jqPagina);
									}else
										dbg(respuesta);
								}
							);
						}
					}else
						dbg(datos);
				}
			);
		};
		
		/**
		 * Actualiza el bloque de info del selector
		 * @param function funcionOk Función a ejecutar cuando se haya actualizado
		 */
		this.actualizarInfo = function(funcionOk){
			if(this.deshabilitado())
				return;
			if(this.jqInput)
				this.jqInput.val(nbf.toJSON(this.valor));
			if(this.jqInfo){
				var thisSel = this;
				var fOk = function(html){
					thisSel.jqInfo.html(html);
					ui.init(thisSel.jqInfo);
					if(funcionOk)
						funcionOk();
				};
				
				nbf.ejecutar(this.claseSelector+"::ajaxInfo",[this.propiedades,this.valor,this.editable],function(html){fOk(html);});				
			}
		};
		
		/**
		 * Determina si el selector es inline
		 * @return bool True si es inline, false en caso contrario
		 */
		this.esInline = function(){
			return (this.propiedades && this.propiedades.inline && this.jqInput);
		};
		
		/**
		 * Muestra la navegación del selector
		 */
		this.mostrarNavegacion = function(){
			if(!this.jqNavegacion){
				if(this.esInline())
					this.jqNavegacion = $("<div />").addClass("inlineNavegacion").appendTo(this.jqInput.closest(".selectorBloque"));
				else
					this.jqNavegacion = ui.crearPopFrame(true);
				this.jqNavegacion.data("selector",this).addClass("nbfSelector");
			}
			if(!this.esInline())
				ui.mostrarPopFrame(this.jqNavegacion);
			else{
				this.jqNavegacion.empty();
				this.jqNavegacion.parents(".popFrame").addClass("backinlineFrame");
				$("body").addClass("backinlineFrame");
			}
		};
		
		/**
		 * Oculta la navegación del selector
		 */
		this.ocultarNavegacion = function(){
			if(this.jqNavegacion){
				if(this.esInline()){
					this.jqNavegacion.parents(".popFrame").removeClass("backinlineFrame");
					$("body").removeClass("backinlineFrame");
					this.jqNavegacion.remove();
				}else
					ui.ocultarPopFrame(this.jqNavegacion);
				this.jqNavegacion = null;				
			}
		};
		
		/**
		 * Retrocede un paso la navegación del selector
		 */
		this.atrasNavegacion = function(){
			if(this.historialNavegacion.length>1){
				var nav = nbf.parseJSON(this.historialNavegacion[this.historialNavegacion.length-2]);
				this.historialNavegacion.pop();
				//desactivamos que se encole historial
				thisSel.noEncolarHistorial = true;
				this.asignarNavegacion(
					nav,
					true,
					function(){
						//volvemos a activar que se pueda encolar historial
						thisSel.noEncolarHistorial = false;
					}
				);			
			}
		};
		
		/**
		 * Determina si se puede retroceder un paso la navegación del selector
		 * @return bool True si aplica, false en caso contrario
		 */
		this.atrasNavegacionAplica = function(){
			return (this.historialNavegacion.length>1);
		};
		
		/**
		 * Cierra la navegación del selector
		 */
		this.cerrarNavegacion = function(){
			this.navegacion = this.navegacionInicial;
			this.historialNavegacion = [];
			this.ocultarNavegacion();
		};
		
		/**
		 * Resetea el valor del selector
		 * @param bool ignorarChange Previene que se lance el evento change
		 */
		this.vaciarValor = function(ignorarChange){
			if(this.deshabilitado())
				return;
			this.valor = "";
			this.actualizarInfo();
			if(!ignorarChange)
				this.change();
		};
		
		/**
		 * Asigna un valor para los datos de valor del selector
		 * @param Object valor Valor a asociar
		 * @param function funcionOk Función a ejecutar cuando se haya actualizado
		 * @param bool ignorarChange Previene que se lance el evento change
		 * @param bool noActualizarInfo Si se pasa a true hace que no se actualice info (llamada ajax, init, etc)
		 */
		this.asignarValor = function(valor,funcionOk,ignorarChange,noActualizarInfo){
			if(this.deshabilitado())
				return;
			this.valor = valor;
			this.cerrarNavegacion();
			if(!noActualizarInfo)
				this.actualizarInfo(funcionOk);
			if(!ignorarChange)
				this.change();
		};
		
		/**
		 * Añade un item para la lista del selector, lo incluirá en el valor si no existe
		 * @param mixed Valor del elemento a incluir
		 * @param function funcionOk Función a ejecutar cuando se haya actualizado
		 * @param bool ignorarChange Previene que se lance el evento change
		 */
		this.anadirItemValor = function(item,funcionOk,ignorarOnChange){
			if(this.deshabilitado())
				return;
			if(!this.valor)
				this.valor = [];
			
			if($.isArray(this.valor)){
				var pos = this.posItemValor(item);
				if(pos>-1) //estaba ya: sobreescribimos
					this.valor[pos] = item;					
				else //no estaba ya: añadimos
					this.valor.push(item);
				this.asignarValor(this.valor,funcionOk,ignorarOnChange);
			}
		};
		
		/**
		 * Añade una lista de items para la lista del selector, incluirá en el valor los que no existan
		 * @param mixed Items a incluir
		 * @param function funcionOk Función a ejecutar cuando se haya actualizado
		 * @param bool ignorarChange Previene que se lance el evento change
		 */
		this.anadirItemsValor = function(items,funcionOk,ignorarOnChange){
			if(this.deshabilitado())
				return;
			//debemos saltar la funcion anadirItemValor para que solo se ejecuten los eventos/cargas una vez
			var valor = this.valor;
			if(!valor)
				valor = [];
			
			if($.isArray(valor)){
				for(var i=0;i<items.length;i++){
					var pos = this.posItemValor(items[i]);
					if(pos>-1) //estaba ya: sobreescribimos
						valor[pos] = items[i];					
					else //no estaba ya: añadimos
						valor.push(items[i]);
				}
				this.asignarValor(valor,funcionOk,ignorarOnChange);				
			}
		};
		
		/**
		 * Elimina un item de la lista del selector
		 * @param mixed Valor del item a eliminar
		 * @param function funcionOk Función a ejecutar cuando se haya actualizado
		 * @param bool ignorarChange Previene que se lance el evento change
		 * @return bool True si se ha eliminado, false en caso contrario
		 */
		this.eliminarItemValor = function(item,funcionOk,ignorarOnChange){
			if(this.deshabilitado())
				return false;
			if($.isArray(this.valor)){
				var pos = this.posItemValor(item);
				if(pos>-1)
					this.eliminarItemPos(pos,funcionOk,ignorarOnChange);
			}
			return false;
		};
		
		/**
		 * Elimina un item de la lista del selector a partir de su posición
		 * @param int pos Posición del item a eliminar
		 * @param function funcionOk Función a ejecutar cuando se haya actualizado
		 * @param bool ignorarChange Previene que se lance el evento change
		 * @return bool True si se ha eliminado, false en caso contrario
		 */
		this.eliminarItemPos = function(pos,funcionOk,ignorarOnChange){
			if(this.deshabilitado())
				return false;
			this.valor.splice(pos,1);
			if(this.valor.length==0)
				this.valor = "";
			this.asignarValor(this.valor,funcionOk,ignorarOnChange);
			return true;
		};
		
		/**
		 * Asigna un valor para la lista del selector, lo incluirá en el valor si no existe
		 * @param mixed Item a comprobar
		 * @return bool True si esta el item, false en caso contrario
		 */
		this.tieneItemValor = function(item){
			return (this.posItemValor(item)>-1);
		};
		
		/**
		 * Determina la posición de un item en el valor
		 * @param mixed Item a comprobar
		 * @return int Posición del item en la lista, -1 si no está
		 */
		this.posItemValor = function(item){
			if($.isArray(this.valor)){
				for(var i=0;i<this.valor.length;i++)
					if(this.compararItemsValor(this.valor[i],item))
						return i;
			}
			return -1;
		};
		
		/**
		 * Compara dos items del valor y devuelve true si son el mismo, false en caso contrario
		 * @param mixed a Primer item a comprobar
		 * @param mixed b Segundo item a comprobar
		 * @return bool True si la comparación ha ido bien, false en caso contrario
		 */
		this.compararItemsValor = function(a,b){
			if($.isArray(a) && $.isArray(b))
				return a[0]==b[0];
			else if($.isPlainObject(a) && $.isPlainObject(b) && a.id && b.id)
				return a.id==b.id;
			else
				return a==b;
		};
		
		/**
		 * Asigna un valor para los datos de navegación del selector
		 * @param Object navegacion Lista de valores a asociar
		 * @param bool resetearNavegacion A true si se quiere resetear la navegación
		 * @param function funcionOk Función a ejecutar cuando se haya actualizado
		 */
		this.asignarNavegacion = function(navegacion,resetearNavegacion,funcionOk){
			if(!resetearNavegacion){
				if(!this.navegacion || this.navegacion.length==0)
					this.navegacion = {};
				for(var valor in navegacion)
					this.navegacion[valor] = navegacion[valor];
			}else
				this.navegacion = navegacion;
			this.actualizarNavegacion(funcionOk);
		};
		
		/**
		 * Asocia el evento change al selector
		 * @param function Función a ejecutar cuando cambia el selector
		 */
		this.change = function(funcion){
			this.evento("change",funcion);
		};
		
		/**
		 * Determina si el selector está deshabilitado
		 * @return bool True si está deshabilitado, false en caso contrario
		 */
		this.deshabilitado = function(){
			return this.deshabilitadoChk;
		};
		
		/**
		 * Marca el selector como deshabilitado o no
		 * @param bool deshab True para deshabilitar, false en caso contrario
		 */
		this.deshabilitar = function(deshab){
			this.deshabilitadoChk = deshab;
		};
		
		/**
		 * Funcion interna para asociar/ejecutar eventos
		 */
		this.evento = function(evento,funcion){
			if(funcion){
				if(!this.ev[evento])
					this.ev[evento] = {"funciones":[],"omitir":false};
				this.ev[evento].funciones.push(funcion);
			}else{
				if(this.ev[evento]){
					if(!this.ev[evento].omitir){
						for(var i=0;i<this.ev[evento].funciones.length;i++)
							this.ev[evento].funciones[i](this);
					}
				}
			}
		};
		
		/**
		 * Determina si se omite un evento o no
		 * @param bool omitir Determina si se omite o no el evento asociado
		 */
		this.omitirEvento = function(evento,omitir){
			if(this.ev[evento])
				this.ev[evento].omitir = omitir;
		};
		
		//atributos
		this.claseSelector = claseSelector;
		this.ev = [];
		if(jqInput){
			this.jqInput = jqInput;
			this.jqInput.data("selector",this).addClass("nbfSelector");
		}
		if(jqInfo){
			this.jqInfo = jqInfo;
			this.jqInfo.data("selector",this).addClass("nbfSelector");
		}
		
		this.propiedades = propiedades;
		this.editable = editable;
		this.multiple = multiple;
		this.deshabilitadoChk = false;
		if(!valorInicial && this.jqInput)
			this.asignarValor(nbf.parseJSON(this.jqInput.val()),null,true,true);
		else
			this.asignarValor(valorInicial);
		
		this.navegacionInicial = {};
		if(navegacionInicial)
			this.navegacionInicial = navegacionInicial;	
		this.navegacion = this.navegacionInicial;
		this.historialNavegacion = [];
	}

	/**
	 * Obtiene el selector asociado a un contenido de su navegacion o info
	 * @param jQuery Elemento sobre el que buscar su selector asociado
	 * @return selector.Selector Objeto de selector asociado
	 */
	function obtener(jqElem){
		jqElem = $(jqElem);
		if(jqElem.hasClass("nbfSelector"))
			return jqElem.eq(0).data("selector");
		else{
			var closest = jqElem.closest(".nbfSelector");
			if(jqElem.hasClass("selectorBloque") || closest.size()==0)
				return jqElem.find(".nbfSelector").eq(0).data("selector");
			else
				return closest.eq(0).data("selector");
		}
	}

	/**
	 * Obtiene el contenedor de pagina asociado al jq pasado
	 * @param jQuery Elemento sobre el que buscar su página de selector asociada
	 * @return jQuery Bloque jQuery de la página asociada
	 */
	function jqPaginaSelector(jqElem){
		return jqElem.closest(".paginaSelector");
	}

	/**
	 * Crea un selector de objeto base
	 * @param string claseObjeto Clase del objeto
	 * @param function funcionOk Función que se invocará cuando el selector asigne algún valor
	 * @param bool multiple Determina si el selector tiene que ser múltiple
	 * @param object propiedadesAdic Objeto con las propiedades adicionales (opcional)
	 * @param function funcionReadyPagina Función que se invocará cuando se muestre la página del selector
	 * @param object navegacionInicial Objeto con las variables de navegación iniciales (opcional)
	 * @return nbf.selector.Selector Objeto de tipo nbf.selector.Selector
	 */
	function crearSelectorObjetoBase(claseObjeto,funcionOk,multiple,propiedadesAdic,funcionReadyPagina,navegacionInicial){
		var claseSelector = "selector\\SelectorObjetoBase";
		if(multiple)
			claseSelector = "selector\\SelectorObjetoBaseConjunto";
		
		var prop = {};
		if(propiedadesAdic)
			prop = propiedadesAdic;
		prop.claseObjeto = claseObjeto;
		
		var sel = new nbf.selector.Selector(claseSelector,prop,null,navegacionInicial);
		sel.change(
			function(){
				funcionOk(sel.valor);
			}
		);	
		sel.actualizarNavegacion(funcionReadyPagina);
		return sel;
	}
	
	return {
		"crearSelectorObjetoBase":crearSelectorObjetoBase,
		"jqPaginaSelector":jqPaginaSelector,
		"obtener":obtener,
		"Selector":Selector
	};
}();

